import Check from '@mui/icons-material/Check';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

type SyncStateProps = {
  pendingMutations: boolean;
};

const SyncStatus = (props: SyncStateProps) => (
  <Grid
    container
    spacing={1}
    sx={{
      alignItems: 'center',
    }}
  >
    <Grid>
      <Typography
        variant="body2"
        color="GrayText"
        sx={{
          lineHeight: 1,
        }}
      >
        {props.pendingMutations ? (
          <CircularProgress
            variant="indeterminate"
            disableShrink
            size={24}
            thickness={4}
            color="inherit"
          />
        ) : (
          <Check />
        )}
      </Typography>
    </Grid>
    <Grid>
      <Typography variant="body2" color="GrayText">
        {props.pendingMutations ? (
          <FormattedMessage {...messages.pending} />
        ) : (
          <FormattedMessage {...messages.upToDate} />
        )}
      </Typography>
    </Grid>
  </Grid>
);

export default SyncStatus;
